const datesReducer = (state = [], action) => {
  switch (action.type) {
    case 'DATES':
      return action.data
    default:
      return state
  }
}

export default datesReducer
